import { memo } from "react"
import { Route, HashRouter as Router, Routes } from "react-router-dom"
import renderRoutes from "./renderRoutes"
import routes from "./routes"
import MapContainer from "@/components/MapContainer"
import HeaderInsights from "@/components/HeaderInsights"
import HeaderPark from "@/components/HeaderPark"
import NoMathPage from "@/pages/NoMatch"
import TabPage from "@/pages/TabPage"

export { renderRoutes, routes }

function Pages() {
  return (
    <Router>
      <Routes>
        {renderRoutes(routes.DefaultRoutes)}
        {/* 飞吉特平台 */}
        <Route
          path="/:cityId"
          element={
            <>
              <MapContainer isShowSwitch={false} isShowPoint={false} />
              <HeaderInsights />
            </>
          }
        >
          {renderRoutes(routes.InsightsRoutes)}
        </Route>
        {/* 园区沙盘 */}
        <Route
          path="/:sandTableId/:cityId"
          element={
            <>
              <HeaderPark />
              <MapContainer
                isShowSwitch={false}
                isShowPoint={false}
                isShowSearch={false}
                isShowController={false}
              />
            </>
          }
        >
          {renderRoutes(routes.ParkRoutes)}
        </Route>
        {/* 金融、品牌沙盘 */}
        <Route path="/:sandTableId/:brandId/:cityId">
          <Route element={<TabPage />}>
            {/* 不需要地图的页面 */}
            {renderRoutes(routes.TabWithoutMapRoutes)}
            {/* 需要地图的页面 */}
            <Route element={<MapContainer />}>{renderRoutes(routes.TabWithMapRoutes)}</Route>
          </Route>
        </Route>
        <Route path="*" element={<NoMathPage />} />
      </Routes>
    </Router>
  )
}

export default memo(Pages)
